(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8924],{

/***/ 26308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/contact.service.ts
var contact_service = __webpack_require__(20644);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Background",
  componentId: "sc-y2oqks-0"
})(["background:", ";margin-bottom:", ";"], function (props) {
  return props.withoutBackground ? props.theme.colors.white : props.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(240));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Wrapper",
  componentId: "sc-y2oqks-1"
})(["padding:", ";margin-top:", ";display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(20));
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Form",
  componentId: "sc-y2oqks-2"
})(["background:", ";padding:", ";border-radius:", ";margin-bottom:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(-200));
var FormFieldsStyles = (0,styled_components_browser_esm/* css */.iv)(["width:100%;padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";display:block;&.error{margin-bottom:0;border-color:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(700));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ContactFormelements__Input",
  componentId: "sc-y2oqks-3"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(50));
var TextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "ContactFormelements__TextArea",
  componentId: "sc-y2oqks-4"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(150));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__ErrorMessage",
  componentId: "sc-y2oqks-5"
})(["margin:", " 0 ", " 0;display:block;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.danger;
});
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__GlobalErrorMessage",
  componentId: "sc-y2oqks-6"
})(["color:", ";padding-top:", ";margin-bottom:-", ";display:block;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10));
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__SuccessMessage",
  componentId: "sc-y2oqks-7"
})(["color:", ";padding-top:", ";display:block;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ContactFormTemplate = function ContactFormTemplate(_ref) {
  var withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  var nameInputRef = (0,react.useRef)();
  var emailInputRef = (0,react.useRef)();
  var phoneInputRef = (0,react.useRef)();
  var messageInputRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      hasNameError = _useState[0],
      setHasNameError = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasEmailError = _useState2[0],
      setHasEmailError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasMessageError = _useState3[0],
      setMessageError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      hasSentError = _useState4[0],
      setHasSentError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isLoading = _useState5[0],
      setIsLoading = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isSent = _useState6[0],
      setIsSent = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      token = _useState7[0],
      setToken = _useState7[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _nameInputRef$current, _emailInputRef$curren, _emailInputRef$curren2, _messageInputRef$curr;

      var hasError, _nameInputRef$current2, _nameInputRef$current3, _emailInputRef$curren3, _phoneInputRef$curren, _phoneInputRef$curren2, _messageInputRef$curr2, _window, _window$fbq, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasNameError(false);
              setHasEmailError(false);
              setMessageError(false);
              setHasSentError(false);
              setIsSent(false);
              hasError = false;

              if (!((nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current = nameInputRef.current) === null || _nameInputRef$current === void 0 ? void 0 : _nameInputRef$current.value) === '')) {
                _context.next = 9;
                break;
              }

              setHasNameError(true);
              return _context.abrupt("return");

            case 9:
              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context.next = 12;
                break;
              }

              setHasEmailError(true);
              return _context.abrupt("return");

            case 12:
              if (!((messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr = messageInputRef.current) === null || _messageInputRef$curr === void 0 ? void 0 : _messageInputRef$curr.value) === '')) {
                _context.next = 15;
                break;
              }

              setMessageError(true);
              return _context.abrupt("return");

            case 15:
              if (!hasError) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              _context.prev = 17;
              setIsLoading(true);
              data = _objectSpread(_objectSpread(_objectSpread({}, (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) && {
                name: nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value
              }), {}, {
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value
              }, (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) && {
                phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value
              }), {}, {
                message: messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr2 = messageInputRef.current) === null || _messageInputRef$curr2 === void 0 ? void 0 : _messageInputRef$curr2.value,
                token: token
              });
              (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT) ? constants/* FBQ_EVENTS.LEAD */.PT.LEAD : constants/* FBQ_EVENTS.CONTACT */.PT.CONTACT);

              if (!router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT)) {
                _context.next = 26;
                break;
              }

              _context.next = 24;
              return contact_service/* contactApi.contactLease */.e.contactLease(data);

            case 24:
              _context.next = 28;
              break;

            case 26:
              _context.next = 28;
              return contact_service/* contactApi.contact */.e.contact(data);

            case 28:
              setIsSent(true);
              setIsLoading(false);
              emailInputRef.current.value = '';
              nameInputRef.current.value = '';
              phoneInputRef.current.value = '';
              messageInputRef.current.value = '';
              _context.next = 39;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](17);
              setHasSentError(true);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 36]]);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var verifyRecaptchaCallback = (0,react.useCallback)(function (token) {
    setToken(token);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    withoutBackground: withoutBackground,
    children: [hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
            tagType: Title/* TitleTagTypes.H3 */.Z.H3,
            alignLeft: true,
            isBlack: true,
            children: t('contact.contact.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: nameInputRef,
            placeholder: t('contact.form.name.placeholder'),
            className: "".concat(hasNameError ? 'error' : '')
          }), hasNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.name.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: emailInputRef,
            placeholder: t('contact.form.email.placeholder'),
            className: "".concat(hasEmailError ? 'error' : '')
          }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.email.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: phoneInputRef,
            placeholder: t('contact.form.phone.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
            ref: messageInputRef,
            placeholder: t('contact.form.message.placeholder'),
            className: "".concat(hasMessageError ? 'error' : '')
          }), hasMessageError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.message.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
            onVerify: verifyRecaptchaCallback
          }), (hasNameError || hasEmailError || hasMessageError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
            children: t('contact.form.error')
          }), !isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: isLoading,
            marginTop: 30,
            onClick: handleClick,
            text: "Odeslat"
          }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: t('contact.form.sent')
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ContactForm = (ContactFormTemplate);

/***/ }),

/***/ 67450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Exhibitors_Exhibitors; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.elements.tsx




var Exhibitors = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitors",
  componentId: "sc-1deaujm-0"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(20));
var Exhibitor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitor",
  componentId: "sc-1deaujm-1"
})(["display:flex;flex-direction:column;width:100%;padding:0;margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20));
var ExhibitorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__ExhibitorTitle",
  componentId: "sc-1deaujm-2"
})(["padding:", " 0 ", " 0;font-weight:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
});
var ExhibitorAnnotation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Exhibitorselements__ExhibitorAnnotation",
  componentId: "sc-1deaujm-3"
})(["color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
});
var ExhibitorImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "Exhibitorselements__ExhibitorImage",
  componentId: "sc-1deaujm-4"
})(["width:", ";height:", ";border-radius:", ";@media (min-width:", "px){width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(155), (0,polished_esm/* rem */.hO)(180), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(190), (0,polished_esm/* rem */.hO)(220));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ExhibitorsTemplate = function ExhibitorsTemplate() {
  var _lecturers$sort;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      lecturers = _useState[0],
      setLecturers = _useState[1];

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    responsive: [{
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false
      }
    }]
  };
  (0,react.useEffect)(function () {
    lecturer_service/* lecturerApi.list */.r.list().then(function (_ref) {
      var data = _ref.data;
      setLecturers(data.results);
    });
  }, []);
  return (lecturers === null || lecturers === void 0 ? void 0 : lecturers.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      isBlack: true,
      children: t('homepage.lecturer.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread(_objectSpread({}, settings), {}, {
        children: lecturers === null || lecturers === void 0 ? void 0 : (_lecturers$sort = lecturers.sort(function (a, b) {
          return a.in_carousel - b.in_carousel;
        })) === null || _lecturers$sort === void 0 ? void 0 : _lecturers$sort.map(function (lecturer, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Exhibitor, {
            onClick: function onClick() {
              return router.push("".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(lecturer.slug));
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorImage, {
              src: lecturer.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar_height.jpg')),
              width: 0,
              height: 0,
              alt: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key),
              loader: function loader(_ref2) {
                var src = _ref2.src;
                return src;
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorTitle, {
              children: (0,person_utils/* formatLecturerName */.v)(lecturer)
            }), (lecturer === null || lecturer === void 0 ? void 0 : lecturer.position) && /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorAnnotation, {
              children: lecturer.position
            })]
          }, key);
        })
      }))
    })]
  });
};

/* harmony default export */ var Exhibitors_Exhibitors = (ExhibitorsTemplate);

/***/ }),

/***/ 31828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* binding */ SUBSCRIPTION_PACKAGES_KEYS; },
/* harmony export */   "QG": function() { return /* binding */ SUBSCRIPTION_PACKAGES; }
/* harmony export */ });
/* unused harmony export SUBSCRIPTION_PACKAGES_KEYS_ENUM */
var SUBSCRIPTION_PACKAGES = [{
  title: 'Daně a účetnictví',
  key: 'taxes',
  moduleId: 'taxes',
  color: '#F2941A',
  saleBoxBackground: '#FAEFE1',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=taxes',
  icon: 'D',
  benefits: ['<span class="bold">80+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc', '<span class="bold">30 % sleva</span> na online systém Daně pro lidi'],
  price: '14 157',
  priceWithoutVat: '11 700'
}, {
  title: 'Mzdy, pracovní právo a personalistika',
  key: 'wages',
  moduleId: 'wages',
  color: '#F00035',
  saleBoxBackground: '#F7DADA',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=wages',
  icon: 'M',
  benefits: ['<span class="bold">80+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc', '<span class="bold">30 % sleva</span> na online systém Mzdy pro lidi'],
  price: '14 157',
  priceWithoutVat: '11 700'
}, {
  title: 'Veřejná správa',
  key: 'government',
  moduleId: 'government',
  color: '#63BF4D',
  saleBoxBackground: '#E7F5E4',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=government',
  icon: 'V',
  benefits: ['<span class="bold">30+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc', '<span class="bold">30 % sleva</span> na online systém Poradce pro veřejnou správu'],
  price: '8 349',
  priceWithoutVat: '6 900'
}];
var SUBSCRIPTION_PACKAGES_KEYS = ['taxes', 'wages', 'government'];
var SUBSCRIPTION_PACKAGES_KEYS_ENUM = {
  TAXES: 'taxes',
  WAGES: 'wages',
  GOVERNMENT: 'government'
};

/***/ }),

/***/ 59922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49642);





var useScrollToSection = function useScrollToSection(sectionNameInPathname, sectionIdInHtml) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.asPath.includes(sectionNameInPathname)) {
      var element = document.getElementById(sectionIdInHtml);
      return window.scrollTo({
        top: element.offsetTop - (window.innerWidth > _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.sm */ .A.sm ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .DESKTOP_HEADER_HEIGHT */ .cf : _constants__WEBPACK_IMPORTED_MODULE_2__/* .MOBILE_HEADER_HEIGHT */ .ZQ),
        behavior: 'smooth'
      });
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToSection);

/***/ }),

/***/ 31227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ rocni_predplatne; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/ContactForm/ContactForm.tsx + 1 modules
var ContactForm = __webpack_require__(26308);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Faqs/Faqs.elements.tsx




var Transportation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__Transportation",
  componentId: "sc-7m7y6v-0"
})(["display:flex;flex-direction:column;margin:", " 0;padding:", ";@media (min-width:", "px){flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(10));
var TransportationOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationOptions",
  componentId: "sc-7m7y6v-1"
})(["width:100%;padding:", " 0;@media (min-width:", "px){width:65%;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md);
var TransportationOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationOption",
  componentId: "sc-7m7y6v-2"
})([""]);
var TransportationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationHeader",
  componentId: "sc-7m7y6v-3"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:", " 0;border-bottom:1px solid ", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
});
var TransportationHeaderTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Faqselements__TransportationHeaderTitle",
  componentId: "sc-7m7y6v-4"
})(["font-size:", ";&.isOpen{color:", ";}"], (0,polished_esm/* rem */.hO)(18), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var TransportationHeaderIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "Faqselements__TransportationHeaderIcon",
  componentId: "sc-7m7y6v-5"
})(["svg{width:", ";height:", ";}&.isOpen{svg{transform:rotate(180deg);}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var TransportationDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationDescription",
  componentId: "sc-7m7y6v-6"
})(["padding:", " 0;line-height:", ";.withBorder{text-decoration:underline;display:block;padding:", " 0;}.question{text-decoration:underline;}li{margin:", " 0;}a{color:", ";text-decoration:underline;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Faqs/Faqs.tsx











var ABOUT_QUESTIONS = [{
  id: 1,
  question: 'about.faq.question1.title',
  answer: 'about.faq.question1.answer.question1'
}, {
  id: 2,
  question: 'about.faq.question2.title',
  answer: 'about.faq.question2.answer.question1'
}, {
  id: 3,
  question: 'about.faq.question3.title',
  answer: 'about.faq.question3.answer.question1'
}, {
  id: 4,
  question: 'about.faq.question4.title',
  answer: 'about.faq.question4.answer.question1'
}, {
  id: 5,
  question: 'about.faq.question5.title',
  answer: 'about.faq.question5.answer.question1'
}, {
  id: 6,
  question: 'about.faq.question6.title',
  answer: 'about.faq.question6.answer.question1'
}];
var SUBSCRIPTION_QUESTIONS = [{
  id: 1,
  question: 'subscription.question1.question',
  answer: 'subscription.question1.answer'
}, {
  id: 2,
  question: 'subscription.question2.question',
  answer: 'subscription.question2.answer'
}, {
  id: 3,
  question: 'subscription.question3.question',
  answer: 'subscription.question3.answer'
}, {
  id: 4,
  question: 'subscription.question4.question',
  answer: 'subscription.question4.answer'
}, {
  id: 5,
  question: 'subscription.question5.question',
  answer: 'subscription.question5.answer'
}, {
  id: 6,
  question: 'subscription.question6.question',
  answer: 'subscription.question6.answer'
}, {
  id: 7,
  question: 'subscription.question7.question',
  answer: 'subscription.question7.answer'
}, {
  id: 8,
  question: 'subscription.question8.question',
  answer: 'subscription.question8.answer'
}, {
  id: 9,
  question: 'subscription.question9.question',
  answer: 'subscription.question9.answer'
}];
var DEFAULT_OPENED_KEY = 'ako-prebieha-online-skolenie';

var FaqsTemplate = function FaqsTemplate() {
  var _ABOUT_QUESTIONS$;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(router.asPath.includes(DEFAULT_OPENED_KEY) ? [(_ABOUT_QUESTIONS$ = ABOUT_QUESTIONS[0]) === null || _ABOUT_QUESTIONS$ === void 0 ? void 0 : _ABOUT_QUESTIONS$.id] : []),
      openedAreas = _useState[0],
      setOpenedAreas = _useState[1];

  (0,useScrollToSection/* default */.Z)(DEFAULT_OPENED_KEY, DEFAULT_OPENED_KEY, 250);

  var toggleTransportationOption = function toggleTransportationOption(option) {
    if (openedAreas.includes(option)) {
      setOpenedAreas([]);
    } else {
      setOpenedAreas([]);
      setTimeout(function () {
        window.scrollTo({
          top: document.getElementById("".concat(option)).offsetTop - 150,
          behavior: 'smooth'
        });
        setOpenedAreas([option]);
      }, 50);
    }
  };

  (0,useScrollToSection/* default */.Z)('faqs', 'faqsId');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    mobileSidePadding: 20,
    id: "faqsId",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Transportation, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        alignLeft: true,
        isBlack: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: t(router.pathname.includes(constants/* ROUTES.SUBSCRIPTION */.Z6.SUBSCRIPTION) ? 'subscription.faq.title' : 'about.faq.title')
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationOptions, {
        children: (router.pathname.includes(constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US) ? ABOUT_QUESTIONS : SUBSCRIPTION_QUESTIONS).map(function (area, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
              id: "".concat(area.id),
              onClick: function onClick() {
                return toggleTransportationOption(area.id);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
                className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                children: t(area.question)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
                className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
              })]
            }), openedAreas.includes(area.id) && /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationDescription, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: t(area.answer)
                }
              })
            })]
          }, key);
        })
      })]
    })
  });
};

/* harmony default export */ var Faqs = (FaqsTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(90359);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/hooks/useCart.tsx + 1 modules
var useCart = __webpack_require__(44722);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Package/Package.tsx + 1 modules
var Package = __webpack_require__(42420);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/packages.ts
var constants_packages = __webpack_require__(31828);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/SubscriptionPackages/Packages.elements.tsx




var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__Background",
  componentId: "sc-1p1uqnz-0"
})([""]);
var Packages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__Packages",
  componentId: "sc-1p1uqnz-1"
})(["display:flex;flex-wrap:wrap;justify-content:center;margin-top:", ";padding-bottom:", ";@media (min-width:", "px){margin-top:", ";}"], (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(80));
var PreTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "Packageselements__PreTitle",
  componentId: "sc-1p1uqnz-2"
})(["font-size:", ";color:", ";line-height:", ";margin-top:", ";margin-bottom:", ";@media (min-width:", "px){text-align:center;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(-60), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Packageselements__Description",
  componentId: "sc-1p1uqnz-3"
})(["font-size:", ";line-height:", ";margin-bottom:", ";@media (min-width:", "px){text-align:center;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.md */.A.md);
var Packages_elements_Package = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__Package",
  componentId: "sc-1p1uqnz-4"
})(["display:flex;flex-direction:column;padding:0 ", ";width:100%;margin:", " ", " 0 ", ";position:relative;border:1px solid ", ";border-radius:", ";@media (min-width:", "px){max-width:", ";}@media (min-width:", "px){max-width:31%;margin:1%;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(120), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(12), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(460), theme/* breakpoints.md */.A.md);
var PackageImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Packageselements__PackageImage",
  componentId: "sc-1p1uqnz-5"
})(["width:", ";margin:-", " auto 0 10%;"], (0,polished_esm/* rem */.hO)(200), (0,polished_esm/* rem */.hO)(100));
var PackageLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Packageselements__PackageLabel",
  componentId: "sc-1p1uqnz-6"
})(["display:block;margin-top:", ";font-size:", ";padding-left:", ";"], (0,polished_esm/* rem */.hO)(4), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(50));
var PackageTitle = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Packageselements__PackageTitle",
  componentId: "sc-1p1uqnz-7"
})(["font-weight:", ";display:flex;align-items:center;gap:", ";margin:", " 0 ", " 0;font-size:", ";height:", ";&:hover,&:focus-visible{color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(50), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
});
var PackagePriceSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__PackagePriceSection",
  componentId: "sc-1p1uqnz-8"
})(["text-align:center;"]);
var PackagePrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Packageselements__PackagePrice",
  componentId: "sc-1p1uqnz-9"
})(["font-weight:", ";font-size:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSizes.h5;
});
var PackagePriceWithoutVat = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Packageselements__PackagePriceWithoutVat",
  componentId: "sc-1p1uqnz-10"
})(["display:block;padding-top:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(10), function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSizes.h6;
});
var PackageDescriptionList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Packageselements__PackageDescriptionList",
  componentId: "sc-1p1uqnz-11"
})(["padding:", " 0 ", " ", ";"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5));
var PackageDescriptionItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Packageselements__PackageDescriptionItem",
  componentId: "sc-1p1uqnz-12"
})(["margin-bottom:", ";color:", ";font-size:", ";line-height:", ";list-style:none;display:flex;svg{width:", ";height:", ";margin-right:", ";margin-top:", ";g polyline{stroke:", ";}}.bold{font-weight:", ";color:", ";}"], (0,polished_esm/* rem */.hO)(15), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.grey;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(28), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(2), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.black;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeights.textBold;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.black;
});
;// CONCATENATED MODULE: ./src/components/SubscriptionPackages/Packages.tsx















var PackagesTemplate = function PackagesTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useCart = (0,useCart/* default */.ZP)(),
      addOrUpdateItemInCart = _useCart.addOrUpdateItemInCart;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PreTitle, {
      children: t('packages.intro.label')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('packages.intro.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: t('packages.intro.description')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('packages.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Packages, {
        children: constants_packages/* SUBSCRIPTION_PACKAGES.map */.QG.map(function (subscriptionPackage, subscriptionPackageKey) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Packages_elements_Package, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PackageImage, {
              src: (0,url_utils/* publicAssets */.VK)("/".concat(subscriptionPackage.key, ".png"))
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PackageTitle, {
              href: subscriptionPackage === null || subscriptionPackage === void 0 ? void 0 : subscriptionPackage.redirectLink,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Package/* default */.Z, {
                symbol: subscriptionPackage.icon,
                color: subscriptionPackage.color
              }), ' ', subscriptionPackage.title]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageLabel, {
              children: t('packages.label1')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageLabel, {
              children: t('packages.label2')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageDescriptionList, {
              children: subscriptionPackage.benefits.map(function (benefit, benefitKey) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(PackageDescriptionItem, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                    name: Icon/* Icons.CheckThin */.PJ.CheckThin
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                      __html: benefit
                    }
                  })]
                }, benefitKey);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackagePriceSection, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PackagePrice, {
                children: [subscriptionPackage.priceWithoutVat, " K\u010D bez DPH / rok"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackagePriceSection, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PackagePriceWithoutVat, {
                children: [subscriptionPackage.price, " K\u010D s DPH / rok"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              marginTop: 20,
              marginBottom: 20,
              text: t('packages.package.button'),
              onClick: function onClick() {
                return addOrUpdateItemInCart(subscriptionPackage.moduleId, 1);
              }
            })]
          }, subscriptionPackageKey);
        })
      })]
    })]
  });
};

/* harmony default export */ var SubscriptionPackages_Packages = (PackagesTemplate);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/ui/Lecturer/Lecturer.tsx + 1 modules
var Lecturer = __webpack_require__(58596);
// EXTERNAL MODULE: ./src/ui/Spinner/Spinner.tsx + 1 modules
var Spinner = __webpack_require__(77368);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/time.utils.ts
var time_utils = __webpack_require__(775);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
;// CONCATENATED MODULE: ./src/components/Archive/Archive.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Wrapper",
  componentId: "sc-dyeh0v-0"
})(["padding:", " 0;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(40));
var Items = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Items",
  componentId: "sc-dyeh0v-1"
})(["margin-top:", ";@media (min-width:", "px){display:flex;justify-content:space-between;flex-wrap:wrap;}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
var Item = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Archiveelements__Item",
  componentId: "sc-dyeh0v-2"
})(["display:flex;flex-direction:column;margin-bottom:", ";cursor:pointer;align-items:center;position:relative;gap:", ";@media (min-width:", "px){flex-direction:row;align-items:flex-start;gap:", ";}@media (min-width:", "px){flex-direction:column;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__ImageSection",
  componentId: "sc-dyeh0v-3"
})(["position:relative;"]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Archiveelements__Image",
  componentId: "sc-dyeh0v-4"
})(["width:", ";height:auto;opacity:0.8;border-radius:", ";"], (0,polished_esm/* rem */.hO)(320), (0,polished_esm/* rem */.hO)(12));
var Topic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Topic",
  componentId: "sc-dyeh0v-5"
})(["width:", ";display:flex;flex-direction:column;@media (min-width:", "px){width:100%;}@media (min-width:", "px){width:", ";height:100%;}"], (0,polished_esm/* rem */.hO)(320), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(320));
var TopicTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Archiveelements__TopicTitle",
  componentId: "sc-dyeh0v-6"
})(["font-size:", ";font-weight:", ";color:", ";display:block;line-height:", ";text-decoration:none;line-clamp:1;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(27));
var TopicTime = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__TopicTime",
  componentId: "sc-dyeh0v-7"
})(["font-size:", ";color:", ";padding:", " 0;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(10));
var TopSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__TopSection",
  componentId: "sc-dyeh0v-8"
})([""]);
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Tags",
  componentId: "sc-dyeh0v-9"
})(["position:absolute;bottom:", ";left:", ";right:", ";display:flex;flex-direction:row;flex-wrap:wrap;gap:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(8));
var Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Archiveelements__Tag",
  componentId: "sc-dyeh0v-10"
})(["font-size:", ";color:", ";padding:", " ", ";border-radius:", ";border:1px solid ", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.textSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(12), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
});
var Archive_elements_Packages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Packages",
  componentId: "sc-dyeh0v-11"
})(["display:flex;margin:", " 0 ", " 0;align-items:center;gap:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(4), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.textBase;
});
var ShowMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__ShowMore",
  componentId: "sc-dyeh0v-12"
})(["display:flex;justify-content:center;"]);
;// CONCATENATED MODULE: ./src/components/Archive/Archive.tsx


















var COUNT_OF_EVENTS_ON_PAGE = 3;

var ArchiveTemplate = function ArchiveTemplate(_ref) {
  var data = _ref.videos,
      count = _ref.count;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(data),
      videos = _useState[0],
      setVideos = _useState[1];

  var _useState2 = (0,react.useState)(count),
      totalCount = _useState2[0],
      setTotalCount = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var showMore = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _yield$calendarApi$ge, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return calendar_service/* calendarApi.getArchiveVideos */.w.getArchiveVideos((videos === null || videos === void 0 ? void 0 : videos.length) + COUNT_OF_EVENTS_ON_PAGE);

            case 3:
              _yield$calendarApi$ge = _context.sent;
              data = _yield$calendarApi$ge.data;
              setVideos(data === null || data === void 0 ? void 0 : data.results);
              setTotalCount(data === null || data === void 0 ? void 0 : data.totalCount);
              setIsLoading(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function showMore() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      isBlack: true,
      children: t('homepage.archive.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Items, {
      children: videos === null || videos === void 0 ? void 0 : videos.map(function (video, videoKey) {
        var _video$video, _video$video$frame, _video$course, _video$video2, _video$lectors, _video$course2, _video$modules, _video$modules2;

        var frameKey = video === null || video === void 0 ? void 0 : (_video$video = video.video) === null || _video$video === void 0 ? void 0 : (_video$video$frame = _video$video.frame) === null || _video$video$frame === void 0 ? void 0 : _video$video$frame.split('/')[0];
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
          href: "".concat(constants/* ROUTES.TRAINING */.Z6.TRAINING, "/").concat(video === null || video === void 0 ? void 0 : (_video$course = video.course) === null || _video$course === void 0 ? void 0 : _video$course.slug),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
            children: video !== null && video !== void 0 && (_video$video2 = video.video) !== null && _video$video2 !== void 0 && _video$video2.frame && frameKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
              src: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/video/").concat(frameKey, "/frame")
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
              src: (0,url_utils/* publicAssets */.VK)('/video_default.jpg')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Topic, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TopSection, {
              children: [video === null || video === void 0 ? void 0 : (_video$lectors = video.lectors) === null || _video$lectors === void 0 ? void 0 : _video$lectors.map(function (person, personKey) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturer/* default */.Z, {
                  image: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(person === null || person === void 0 ? void 0 : person.photo),
                  name: (0,person_utils/* formatLecturerName */.v)(person)
                }, personKey);
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TopicTitle, {
                children: video === null || video === void 0 ? void 0 : (_video$course2 = video.course) === null || _video$course2 === void 0 ? void 0 : _video$course2.title
              }), (video === null || video === void 0 ? void 0 : (_video$modules = video.modules) === null || _video$modules === void 0 ? void 0 : _video$modules.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Archive_elements_Packages, {
                children: [t('homepage.archive.subscription'), ":", video === null || video === void 0 ? void 0 : (_video$modules2 = video.modules) === null || _video$modules2 === void 0 ? void 0 : _video$modules2.map(function (module, key) {
                  var subscriptionPackage = constants_packages/* SUBSCRIPTION_PACKAGES.find */.QG.find(function (subPackage) {
                    return subPackage.key === module._key;
                  });
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Package/* default */.Z, {
                      color: subscriptionPackage.color,
                      symbol: subscriptionPackage.icon
                    })
                  }, key);
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicTime, {
                children: [t('homepage.archive.duration'), ":", ' ', (0,time_utils/* parseHourAndMinutes */.lT)(Number(video.video.duration)), ' ']
              })]
            })
          })]
        }, videoKey);
      })
    }), (videos === null || videos === void 0 ? void 0 : videos.length) < totalCount && /*#__PURE__*/(0,jsx_runtime.jsx)(ShowMore, {
      children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
        size: 32
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: showMore,
        whiteType: true,
        text: t('homepage.calendar.button')
      })
    })]
  });
};

/* harmony default export */ var Archive = (ArchiveTemplate);
// EXTERNAL MODULE: ./src/components/Exhibitors/Exhibitors.tsx + 1 modules
var Exhibitors = __webpack_require__(67450);
;// CONCATENATED MODULE: ./src/pages/rocni-predplatne.tsx

















var ClassroomRent = function ClassroomRent(_ref) {
  var videos = _ref.videos,
      videosCount = _ref.videosCount;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.subscription.title'),
      description: t('seo.subscription.description'),
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "subscription.hero.title",
      imageKey: "subscription_hero.webp",
      listKeys: ['subscription.hero.paragraph1', 'subscription.hero.paragraph0', 'subscription.hero.paragraph2', 'subscription.hero.paragraph3', 'subscription.hero.paragraph7', 'subscription.hero.paragraph4', 'subscription.hero.paragraph6']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriptionPackages_Packages, {}), videosCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Archive, {
        videos: videos,
        count: videosCount
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var rocni_predplatne = (ClassroomRent);

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ contactApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var CONTACT = 'pv/contact';
var LEASE = 'pv/contact/lease-form';
var COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';
var contactApi = {
  contact: function contact(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(CONTACT, data);
  },
  contactLease: function contactLease(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(LEASE, data);
  },
  companyCoursesOrder: function companyCoursesOrder(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(COMPANY_COURSES_ORDER, data);
  }
};

/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ lecturerApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'person/list/carousel';
var DETAIL = 'pv/person/slug';
var lecturerApi = {
  list: function list() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST);
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  },
  upcomingTrainings: function upcomingTrainings(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  },
  upcomingConferences: function upcomingConferences(slug, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/conferences"), {
      limit: limit,
      offset: offset
    });
  },
  records: function records(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/archived/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  }
};

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-1"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-2"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-3"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-4"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(30), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx









var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      descriptionKey = _ref.descriptionKey,
      listKeys = _ref.listKeys;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        dangerouslySetInnerHTML: {
          __html: t(titleKey)
        }
      }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        dangerouslySetInnerHTML: {
          __html: t(descriptionKey)
        }
      }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: t(listKey)
            }
          })]
        }, key);
      }))]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 58596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Lecturer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.elements.tsx



var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Wrapper",
  componentId: "sc-1urcrvf-0"
})(["display:inline-flex;align-items:center;margin-right:", ";margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Lecturerelements__ImageSection",
  componentId: "sc-1urcrvf-1"
})(["position:relative;width:", ";height:", ";overflow:hidden;border-radius:50%;margin-right:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(2));
var Photo = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "Lecturerelements__Photo",
  componentId: "sc-1urcrvf-2"
})(["position:absolute;left:50%;top:50%;width:100%;height:auto;transform:translate(-50%,-50%);"]);
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Title",
  componentId: "sc-1urcrvf-3"
})(["font-weight:", ";color:", ";"], function (prop) {
  return prop.isBold ? prop.theme.fontWeights.textBold : prop.theme.fontWeights.textRegular;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.tsx







var LecturerTemplate = function LecturerTemplate(_ref) {
  var image = _ref.image,
      isBold = _ref.isBold,
      name = _ref.name,
      slug = _ref.slug;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    onClick: function onClick() {
      return slug && router.push({
        pathname: "".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(slug)
      });
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Photo, {
        src: image,
        width: 0,
        height: 0,
        alt: name,
        loader: function loader(_ref2) {
          var src = _ref2.src;
          return src;
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: name
    })]
  });
};

/* harmony default export */ var Lecturer = (LecturerTemplate);

/***/ }),

/***/ 42420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Package; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Package/Package.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageelements__Wrapper",
  componentId: "sc-1xcvnya-0"
})(["display:inline-flex;width:", ";min-width:", ";height:", ";background:", ";align-items:center;justify-content:center;border-radius:", ";color:", ";font-weight:", ";font-size:", ";margin:0 ", " 0 ", ";"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(22), function (props) {
  return props.background;
}, (0,polished_esm/* rem */.hO)(24), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textRegular;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Package/Package.tsx





var PackageTemplate = function PackageTemplate(_ref) {
  var symbol = _ref.symbol,
      color = _ref.color;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    background: color,
    children: symbol
  });
};

/* harmony default export */ var Package = (PackageTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatLecturerName; }
/* harmony export */ });
var formatLecturerName = function formatLecturerName(person) {
  if (!person) return;
  return "".concat(person.titles.before_name ? "".concat(person.titles.before_name, " ") : '').concat(person.name, " ").concat(person.surname).concat(person.titles.after_name ? " ".concat(person.titles.after_name) : '');
};

/***/ }),

/***/ 18787:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rocni-predplatne",
      function () {
        return __webpack_require__(31227);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,5675,6066,5897,9774,2888,179], function() { return __webpack_exec__(18787); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);